import React from 'react';
import i18n from 'i18n-js';
import toastr from 'toastr';

import * as Yup from 'yup';

import { Formik, Field, Form } from 'formik';

import { FormGroup, Col, FormFeedback, Button, Input, Card, CardBody } from 'reactstrap';

import API from '../../api/index';

export default function EditPassword({ user }) {
  return (
    <div className="view">
      <div className="view-header">
        <header className="title text-white">
          <h1 className="h4 text-uppercase">{i18n.t('edit_password_title')}</h1>
          <p className="mb-0">{i18n.t('edit_password')}</p>
        </header>
      </div>
      <ViewContent user={user} />
    </div>
  );
}

function ViewContent({ user }) {
  return (
    <div className="view-content view-components">
      <Card className="mb-4">
        <CardBody className="table-responsive">
          <h6 className="mb-4 text-uppercase">{i18n.t('new_password_title')}</h6>
          {user && <EditPasswordForm {...{ user }} />}
        </CardBody>
      </Card>
    </div>
  );
}

function EditPasswordForm({ user }) {
  const onSubmit = params => {
    const userObj = {
      ...user,
      password: params.password,
      passwordConfirmation: params.passwordConfirmation
    };

    API.call('users.edit_profile', userObj, (err, user) => {
      if (err) {
        toastr.error(err.reason);
      } else {
        toastr.success('OK!');
      }
    });
  };

  return (
    <Formik
      initialValues={{
        password: '',
        passwordConfirmation: ''
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string()
          .min(6, i18n.t('password_too_short'))
          .required(i18n.t('password_required')),
        passwordConfirmation: Yup.string()
          .min(6, i18n.t('password_too_short'))
          .oneOf([Yup.ref('password'), null], i18n.t('password_confirm_not_match'))
          .required(i18n.t('password_confirm_required'))
      })}
      onSubmit={onSubmit}
    >
      {({ errors, touched }) => (
        <Form>
          <Col msm={9}>
            <FormGroup>
              <Input
                placeholder={i18n.t('password_field')}
                className="form_item text_form"
                type="password"
                name="password"
                tag={Field}
                invalid={errors.password && touched.password}
              />
              {errors.password && touched.password && (
                <FormFeedback>{errors.password}</FormFeedback>
              )}
            </FormGroup>
            <FormGroup>
              <Input
                placeholder={i18n.t('password_confirm_field')}
                className="form_item text_form"
                type="password"
                name="passwordConfirmation"
                tag={Field}
                invalid={errors.passwordConfirmation && touched.passwordConfirmation}
              />
              {errors.passwordConfirmation && touched.passwordConfirmation && (
                <FormFeedback>{errors.passwordConfirmation}</FormFeedback>
              )}
            </FormGroup>
          </Col>
          <Button color="primary" type="submit" className="form_bt bt_common m_15">
            {i18n.t('save_button')}
          </Button>
        </Form>
      )}
    </Formik>
  );
}
